const swipeEvents = {

    isError: (eventType) => {
        switch (eventType) {
            case swipeEvents.ACCESS_DENIED_SENTINEL:
            case swipeEvents.ACCESS_DENIED_SITE:
            case swipeEvents.SPOT_CHECK_DENIED:
            case swipeEvents.VP_ACCESS_DENIED_SITE:
            case swipeEvents.VP_ACCESS_DENIED_SENTINEL:
            case swipeEvents.VISITOR_PASS_CANCELLED:
            case swipeEvents.AWARD_COMPETENCE_DENIED:
            case swipeEvents.CARD_CANCELLED:
            case swipeEvents.CARD_EXPIRED:
            case swipeEvents.CARD_CSCS_EXPIRED:
            case swipeEvents.CARD_SUSPENDED:
            case swipeEvents.CARD_SUSPENDED_FOR_DIVISION:
            case swipeEvents.WORKER_SUBSCRIPTION_EXPIRED:
            case swipeEvents.WORKER_SUBSCRIPTION_PENDING:
            case swipeEvents.INVALID_COMPETENCES:
            case swipeEvents.NO_PRIMARY_EMPLOYER:
            case swipeEvents.NO_SPONSOR:
                return true;
            default:
                return false;
        }
    },

    CARD_READ: "Card Read",
    CARD_CHECK: "Spot Check",
    CARDLESS_CHECK: "Cardless Spot Check",
    SPOT_CHECK_DENIED: "Spot Check Denied",
    CARD_SWIPE: "Swipe In",
    CARD_SWIPE_OUT: "Swipe Out",
    SELF_SWIPE_IN: "Self Swipe In",
    SELF_SWIPE_OUT: "Self Swipe Out",
    TEAM_SWIPE_OUT: "Team Swipe Out",
    CARDLESS_SWIPE: "Cardless Swipe In",
    CARDLESS_SWIPE_OUT: "Cardless Swipe Out",
    VP_CHECK: "Visitor Spot Check",
    VP_SWIPE: "Visitor Swipe In",
    VP_SWIPE_OUT: "Visitor Swipe Out",
    VP_TEAM_SWIPE_OUT: "Visitor Team Swipe Out",

    ACCESS_DENIED_SITE: "Access Denied - Manual",
    ACCESS_DENIED_SENTINEL: "Access Denied - System",
    VP_ACCESS_DENIED_SITE: "Visitor Access Denied - Manual",
    VP_ACCESS_DENIED_SENTINEL: "Visitor Access Denied - System",
    VISITOR_PASS_CANCELLED: "Visitor Pass Cancelled",
    VISITOR_SUSPENDED: "Visitor Suspended",
    AWARD_COMPETENCE: "Award Competency",
    CARDLESS_AWARD_COMPETENCE: "Cardless Award Competency",
    VP_AWARD_COMPETENCE: "Visitor Award Competency",
    VP_AWARD_COMPETENCE_DENIED: "Visitor Award Competency Denied",
    AWARD_COMPETENCE_DENIED: "Award Competency Denied",
    CARD_CANCELLED: "Card Cancelled",
    CARD_EXPIRED: "Card Expired",
    CARD_CSCS_EXPIRED: "Card Expired in CSCS",
    CARD_SUSPENDED: "Person Suspended Nationally",
    CARD_SUSPENDED_FOR_DIVISION: "Person Blocked on Network",
    WORKER_SUBSCRIPTION_EXPIRED: "Worker Subscription Expired",
    WORKER_SUBSCRIPTION_PENDING: "Worker Subscription Pending",
    INVALID_COMPETENCES: "Invalid requirements",
    NO_PRIMARY_EMPLOYER: "No Employer",
    NO_SPONSOR: "No Sponsor",

    CARD_CANCELLED_ID: "CBBFDBE4-4E00-4FD6-8ABB-C8395EDD70D4",
    CARD_CANCELLED_MESSAGE: "Card Cancelled",

    CARD_EXPIRED_ID: "750AFA76-427D-4639-B424-F9E67102BE21",
    CARD_EXPIRED_MESSAGE: "Card Expired",

    CARD_SUSPENDED_ID: "1A5C268F-05CF-4322-A3F8-4AA9CF79B398",
    CARD_SUSPENDED_MESSAGE: "Suspended Nationally",

    CARD_SUSPENDED_FOR_DIVISION_ID: "705C0F85-A9ED-4C1B-87AB-6E0884E7B1AE",
    CARD_SUSPENDED_FOR_DIVISION_MESSAGE: "Network Block",

    CARD_SUSPENDED_FOR_SITE_ID: "44B0C788-2DED-4DA2-996E-C0BA98B4DFCB",
    CARD_SUSPENDED_FOR_SITE_REASON: "Site Block",

    WORKER_SUBSCRIPTION_EXPIRED_ID: "02808BBB-DBBF-4A52-B6EC-E4581A6632EA",
    WORKER_SUBSCRIPTION_EXPIRED_MESSAGE: "Subscription Expired",

    WORKER_SUBSCRIPTION_PENDING_ID: "41C4EFBE-0995-458A-82E3-B22455B706A3",
    WORKER_SUBSCRIPTION_PENDING_MESSAGE: "Subscription Pending",

    INVALID_COMPETENCES_ID: "D010E1E3-A467-48BA-A523-45F000FEBAA9",
    INVALID_COMPETENCES_MESSAGE: "Invalid requirements",

    INVALID_COMPETENCES_MULTIPLE_ID : "FFA64609-917F-4D31-B292-FF9061FC1F04",
    INVALID_COMPETENCES_MULTIPLE_MESSAGE : "Invalid requirements - Multiple",

    INVALID_COMPETENCES_NATIONAL_ID : "3B80943B-9554-4CAB-864D-D41837D5886E",
    INVALID_COMPETENCES_NATIONAL_MESSAGE : "Invalid requirements - National",

    INVALID_COMPETENCES_EMPLOYER_ID : "7B9CA32B-9723-4DFD-BF3F-C01FA07D8F0A",
    INVALID_COMPETENCES_EMPLOYER_MESSAGE : "Invalid requirements - Employer",

    INVALID_COMPETENCES_DIVISION_ID : "37327B8D-6B5C-49F6-AA81-3BFD1FB519A4",
    INVALID_COMPETENCES_DIVISION_MESSAGE : "Invalid requirements - Entity",

    INVALID_COMPETENCES_PROJECT_ID : "B7AC7EF2-D174-4417-BCDE-100460E98C64",
    INVALID_COMPETENCES_PROJECT_MESSAGE : "Invalid requirements - Project",

    INVALID_COMPETENCES_SITE_ID : "DF9732FA-7125-4FE9-8583-F62461BA6036",
    INVALID_COMPETENCES_SITE_MESSAGE : "Invalid requirements - Site",

    INVALID_COMPETENCES_ZONE_ID : "E660E8C5-25A7-42BA-81E2-B6A741B97BE6",
    INVALID_COMPETENCES_ZONE_MESSAGE : "Invalid requirements - Zone",

    INVALID_COMPETENCES_CARD_ID : "D7CB2309-B38B-46F5-837D-246313A47CE3",
    INVALID_COMPETENCES_CARD_MESSAGE : "Invalid requirements - Compatible Skills Card",

    NO_PRIMARY_EMPLOYER_ID: "19DD33AA-CD97-48E7-BA54-00520E5FB139",
    NO_PRIMARY_EMPLOYER_MESSAGE: "No Employer",

    VP_CANCELLED_ID: "522BE7D0-F28E-4A09-BB3B-2597093297FE",
    VP_CANCELLED_MESSAGE: "Visitor Pass Cancelled",

    VP_INVALID_DATE_ID: "EF6B355A-56B3-47B4-A6FA-132C580AEBC8",
    VP_INVALID_DATE_MESSAGE: "Visitor Pass Invalid Date",

    VP_INVALID_SITE_ID: "BE163E5B-96DB-4145-95AD-25E9FFDD0A57",
    VP_INVALID_SITE_MESSAGE: "Visitor Pass Invalid Site",

    NO_SPONSOR_ID: "37D93E4B-FD21-4D76-9FA6-BBD8EE5E5F3A",
    NO_SPONSOR_MESSAGE: "No Sponsor"
};

export default swipeEvents;